module.exports = __webpack_public_path__ + "img/vende_tu_auto_documentos_web.518ac87c.png";